import { buildSchema, buildProperty } from "@camberi/firecms";

export const productSchema = buildSchema({
    name: "Price",
    properties: {
        name: {
            title: "Product Name",
            dataType: "string",
            disabled: true,
            validation: { required: true },
        },
        active: {
            title: "Status",
            dataType: "boolean",
            disabled: true,
            validation: { required: true },
        },
        prices: buildProperty({
            title: "Price",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
        }),
        
    },
    defaultValues: {
        status: false,
        order: 0
    }
});

export const priceSchema = buildSchema({
    name: "Price",
    properties: {
        stripe_metadata_nickName: {
            title: "Stripe MetaData Name",
            dataType: "string",
            disabled: true,
            validation: { required: true },
        },
        product: {
            title: "Product",
            dataType: "string",
            disabled: true,
            validation: { required: true },
        },
        name: {
            title: "Name",
            dataType: "string",
            validation: { required: true },
        },
        content: buildProperty({
            title: "Content",
            description: "Content",
            validation: { required: true },
            dataType: "array",
            of: {
                dataType: "string",
                config: {
                    // previewAsTag: true
                }
            }
        }),
        currency: {
            title: "Currency",
            dataType: "string",
            disabled: true,
            validation: { required: true },
        },
        unit_amount: {
            title: "Amount",
            dataType: "number",
            disabled: true,
            validation: { required: true },
            
        },
        active: buildProperty({
            title: "Status",
            dataType: "boolean",
            disabled: true,
            validation: { required: true },
        }),
        showDefault: buildProperty({
            title: "Show Default",
            dataType: "boolean"
        }),
        
    },
    defaultValues: {
        status: false,
        order: 0
    }
});
